import React from 'react'
import Menubar from './Menubar'
import Footer from './Footer'
export default function About(){
    return(
        <>
        <Menubar/>
        <div className='container'>
        <h1>About Page</h1>
        </div>
        
        <Footer/>
        </>
    )
}